import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import ko from "./i18n/locales/ko.json";
import en from "./i18n/locales/en.json";
import ja from "./i18n/locales/ja.json";
import zh from "./i18n/locales/zh.json";

const SUPPORTED_LANGUAGES = ["ko", "en", "ja", "zh"];

const LANGUAGE_STORAGE_KEY = "appLanguage";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ko: { translation: ko },
      en: { translation: en },
      ja: { translation: ja },
      zh: { translation: zh },
    },
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGUAGES,
    // en-US 같은 지역 변형도 base(en)로 매칭
    nonExplicitSupportedLngs: true,
    load: "languageOnly",
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage"],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
      caches: ["localStorage"],
    },
    react: { useSuspense: false },
  });

export default i18n;
